var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84622 0.896269C6.05125 0.691235 6.05125 0.358809 5.84622 0.153775C5.64119 -0.0512585 5.30876 -0.0512585 5.10373 0.153775L3 2.2575L0.896274 0.153776C0.691241 -0.051258 0.358815 -0.0512582 0.153782 0.153776C-0.0512519 0.358809 -0.0512518 0.691235 0.153782 0.896269L2.25751 3L0.153775 5.10373C-0.0512583 5.30876 -0.0512585 5.64119 0.153775 5.84622C0.358809 6.05126 0.691234 6.05126 0.896268 5.84622L3 3.74249L5.10373 5.84622C5.30877 6.05126 5.64119 6.05126 5.84623 5.84622C6.05126 5.64119 6.05126 5.30876 5.84623 5.10373L3.74249 3L5.84622 0.896269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2a9c068130d0be5fe4868e8003cca43d.svg";
export { ForwardRef as ReactComponent };